<div class="dd-vehicle-detail-header" *ngIf="vehicleDetails">
  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between stretch" class="dd-top-section dd-content-margin">

    <div fxLayout="column" class="dd-left-section-max-width">
        <div class="dd-model-details" innerHTML="{{sharedFunctionService.getFormattedYearMarketingName(vehicleDetails)}}"></div>
        <div class="dd-vin-details" [ngClass] = "{'dd-vin-details-lexus': dealerDetails?.isLexus}">
            <div class="dd-model-code">
              <div [innerHTML]="vehicleModel"></div>
            </div>
            <div class="dd-vin" *ngIf="!deleteVin">
              <div>VIN:</div>
              <div [innerHTML]="vehicleDetails?.vin"></div>
            </div>
            <div class="dd-stock-no">
              <div>Stock:</div>
              <div [innerHTML]="vehicleDetails?.stockNum"></div>
            </div>
            <div>Engine: {{ vehicleDetails?.engine?.name }}</div>
            <div class="dd-transmission">Transmission: {{ vehicleDetails?.transmission?.transmissionType }}</div>
            <div class="dd-brochure-mobile" fxShow.gt-sm="false" fxShow="true" *ngIf="showEbrochure | async">
                <mat-icon class="material-icons dd-ebrochure-icon" aria-label="eBrochure" rol="img">
                    <img src="assets/icons/icon-download.svg" />
                  </mat-icon>
                  <a [href]="eBrochureURL"
                    download="" target="_blank" (click)="omTag.fireOmnitureTag('vd_km-rab-download', {url:$event.srcElement.href, href: $event.srcElement.href, text:$event.srcElement.innerText, trigger:'km-link'}, sharedData)">eBrochure</a>
              </div>
        </div>
    </div>
    <div fxLayoutAlign="center center" class="dd-carousel-wrapper">
      <div class="dd-carousel-container" >
        <div id="myCarousel" (swipe)="swipe($event)" class="carousel slide img-rectangular" data-ride="carousel" data-interval="false">
          <!-- [ngClass]="{ 'img-rectangular-scroll' : sharedData.showShrinkImage }" -->
          <!-- Indicators -->

          <div *ngIf="showIndicator === true && imgExterior !== null && imgExterior.length > 0">
            <!-- *ngIf="!sharedData.showShrinkImage" -->
            <ol class="carousel-indicators dd-ext-carousel-indicator-container">EXTERIOR
              <ng-template ngFor let-item [ngForOf]="imgExterior" let-i="index">
                <li data-target="#myCarousel" class="dd-carousel-indicator" attr.data-slide-to="{{i}}" [ngClass]="{'active' : i == 0}"
                  (click)="carouselActive('EXT');omTag.fireOmnitureTag('vd_aa-link_vehicle_header_module',{url:item.href, href: item.href, text:'exterior', trigger:'aa-link', listIndex: i + 1}, sharedData);"></li>
              </ng-template>
            </ol>

            <ol class="carousel-indicators dd-int-carousel-indicator-container">INTERIOR
              <ng-template ngFor let-item [ngForOf]="imgInterior" let-k="index">
                <li data-target="#myCarousel" class="dd-carousel-indicator" attr.data-slide-to="{{ k + imgExterior.length }}"
                  (click)="carouselActive('INT');omTag.fireOmnitureTag('vd_aa-link_vehicle_header_module',{url:item.href, href: item.href, text:'interior', trigger:'aa-link', listIndex: (k + imgExterior.length + 1)}, sharedData);"></li>
              </ng-template>
            </ol>
          </div>

          <!-- Wrapper for slides -->
          <div class="carousel-inner" fxLayoutAlign="center center">
            <div *ngFor="let image of imgExterior; let i = index" class="item dd-img-container" [ngClass]="{'active' : i == 0}">
              <img [src]="image.href" alt="" [ngClass] = "{'dd-carousel-vehicle-img-ext-lexus': dealerDetails?.isLexus, 'dd-carousel-vehicle-img-ext': image.href?.includes('media.rti')}">
              <!-- Hayley’s comment 7 months ago and this change so any future SET image changes on VSPEC will point to SET altering g their images despite SETs claims of no image changes. -->
            </div>
            <div *ngFor="let image of imgInterior" class="item dd-img-container">
              <ng-container *ngIf="image.source !== 'PORT'">
                <img [src]="image.href" alt="" class="dd-carousel-vehicle-img-int" [ngClass] = "{'dd-carousel-vehicle-img-int-lexus': dealerDetails?.isLexus}">
              </ng-container>
              <ng-container *ngIf="image.source === 'PORT'">
                <dd-three-sixty-photo-viewer [imageUrl]="image.href"></dd-three-sixty-photo-viewer>
              </ng-container>
            </div>
          </div>
          <div *ngIf="imgExterior === null || imgExterior === undefined || imgExterior.length === 0" class="dd-no-img-container">
            <img src="assets/icons/icon-no-image.svg" alt="" class="dd-no-image">
          </div>
          <!-- Left and right controls -->
          <a href="#myCarousel" id="carousel-prev-nav" data-slide="prev" style="display:none;"> <!-- *ngIf="hideImageCarouselNavigation === false && !sharedData.showShrinkImage" -->
            <mat-icon fxShow.gt-xs="true" fxShow="false" class="material-icons" aria-label="Left" style="height: auto; width: auto; font-size: 55px; position: absolute;  top:44%;  left:-7%;color:#CC0000;">chevron_left
            </mat-icon>
            <mat-icon fxShow.gt-xs="false" fxShow="true" class="material-icons" aria-label="Left" style="height: auto; width: auto; font-size: 55px; position: absolute;  top:30%;  left:-17%;color:#CC0000;">chevron_left
            </mat-icon>
          </a>
          <a href="#myCarousel"  id="carousel-next-nav"  data-slide="next" style="display:none;">
            <mat-icon fxShow.gt-xs="true" fxShow="false" class="material-icons" aria-label="Right" style="height: auto; width: auto; font-size: 55px; position: absolute;  top:44%;  right:-7%;color:#CC0000;">chevron_right
            </mat-icon>
            <mat-icon fxShow.gt-xs="false" fxShow="true" class="material-icons" aria-label="Right" style="height: auto; width: auto; font-size: 55px; position: absolute;  top:30%;  right:-17%;color:#CC0000;">chevron_right
            </mat-icon>
          </a>
        </div>
      </div>
    </div>
    <div style="padding-top:2.5%;" fxShow.gt-sm="true" fxShow="false">
      <div fxLayoutAlign="center center" class="dd-ebrochure-nonmobile" *ngIf="showEbrochure | async">
        <mat-icon class="material-icons dd-ebrochure-icon" aria-label="eBrochure" rol="img">
          <img src="assets/icons/icon-download.svg" />
        </mat-icon>
        <a [href]="eBrochureURL"
          download="" target="_blank" (click)="omTag.fireOmnitureTag('vd_km-rab-download', {url:$event.srcElement.href, href: $event.srcElement.href, text:$event.srcElement.innerText, trigger:'km-link'}, sharedData)">eBrochure</a>
      </div>
    </div>
    <div fxLayout="column" class="dd-right-section-max-width" *ngIf="dealerDetails">
      <div class="dd-vin-right-details">
        <div fxLayout="column" fxLayoutAlign="center end" class="dd-content-margin dd-download-pdf-btn-container">
          <div>
            <button *ngIf="!dealerDetails?.isLexus" id="printButtonNoLexus" (click)="printPDF()" class="dd-btn-download" style="margin-bottom: 10px;">
              <span style="margin-left: -12px;"><img style="padding-right: 1%;vertical-align: middle;" src="./assets/icons/icon-print.png"  width="32px" height="28px"/></span>
              ADD NOTES/PRINT
            </button>
            <button  *ngIf="dealerDetails?.isLexus" (click)="printPDF()" id="printButtonIsLexus" class="dd-btn-download-lexus" style="margin-bottom: 10px;">
              <span style="margin-left: -12px;"><img style="padding-right: 1%;vertical-align: middle;" src="./assets/icons/icon-print.png"  width="32px" height="28px"/></span>
              ADD NOTES/PRINT
            </button>
          </div>
          <div>
            <button id="printButton" *ngIf="!dealerDetails?.isLexus" class="dd-btn-download" style="margin-bottom: 10px;" (click)="downloadPDF($event)"><img style="padding-right: 6%;vertical-align: middle;"
              src="./assets/icons/icon-download-white.svg" />DOWNLOAD AS PDF</button>
            <button *ngIf="dealerDetails?.isLexus" class="dd-btn-download-lexus" style="margin-bottom: 10px;" (click)="downloadPDF($event)"><img style="padding-right: 6%;vertical-align: middle;"
              src="./assets/icons/icon-download-white.svg" />DOWNLOAD AS PDF</button>
          </div>
        </div>
    </div>
  </div>
</div>
